import { clsx } from 'clsx'
import { type FC } from 'react'

import { HStack, Text, type HStackProps, type TextProps } from '@/components'

export interface RedBadgeProps extends Omit<HStackProps, 'children'> {
  count: number
  textClassName?: TextProps['className']
}

export const RedBadge: FC<RedBadgeProps> = ({ className, count, textClassName }) => (
  <HStack
    accessibilityElementsHidden
    aria-hidden
    className={clsx('h-6 min-w-6 items-center justify-center rounded-full bg-brand-orange-500 px-1', className)}
    importantForAccessibility='no-hide-descendants'
  >
    <Text className={clsx('font-poppinsBold text-xs text-white', textClassName)}>{count > 99 ? '99+' : count}</Text>
  </HStack>
)
